// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w1-8";
export var editMode = "_w1-3";
export var headerRow = "_w1-a";
export var headerTitle = "_w1-b";
export var product = "_w1-1";
export var productDetails = "_w1-5";
export var productDivider = "_w1-7";
export var productImage = "_w1-2";
export var productInfo = "_w1-4";
export var productTitle = "_w1-6";
export var strikethrough = "_w1-9";
export var upsellProductsCard = "_w1-0";